import React from "react";

type TimeRulerProps = {
  totalDuration: number;
  pxPerSec: number;
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

export function TimeRuler({ totalDuration, pxPerSec, onMouseDown }: TimeRulerProps) {
  const step =
    totalDuration <= 10 ? 1 : totalDuration <= 30 ? 5 : totalDuration <= 120 ? 10 : 30;
  const markers: number[] = [];
  for (let t = 0; t <= totalDuration; t += step) markers.push(t);

  return (
    <div
      className="relative h-[28px] border-b border-[#e2e8f0] bg-[#f8fafc] select-none"
      onMouseDown={onMouseDown}
      style={{ cursor: onMouseDown ? "col-resize" : "default" }}
    >
      {markers.map((t) => (
        <div
          key={t}
          className="absolute flex flex-col items-center"
          style={{ left: t * pxPerSec, transform: "translateX(-50%)" }}
        >
          <div className="w-px h-[6px] bg-[#cbd5e1]" />
          <span className="text-[10px] text-[#94a3b8] mt-0.5 whitespace-nowrap">{t}s</span>
        </div>
      ))}
    </div>
  );
}
